<template>
  <q-dialog ref="dialogRef" persistent @hide="onDialogHide">
    <q-card
      :style="{
        minWidth: '600px',
        maxWidth: '600px',
      }"
      class="relative-position elevation-1"
    >
      <q-card-section
        class="flex justify-between items-center q-px-2x-md q-py-xl"
      >
        <span class="text-lg text-neutral text-weight-medium">
          {{ headerText }}
        </span>

        <PBtn flat dense round size="sm" @click="() => onDialogCancel()">
          <CloseIcon class="icon" />
        </PBtn>
      </q-card-section>

      <q-separator></q-separator>

      <q-card-section
        class="rounded-borders text-neutral-90 q-px-2x-md q-py-xl"
      >
        <q-form @submit="onSubmit">
          <div :class="labelClass">
            {{ labelText }}
          </div>
          <div :class="hintClass" class="q-mt-xs">
            {{ hintText }}
          </div>

          <div class="flex justify-end q-mt-xl">
            <PBtn
              :fluid="false"
              :loading="isLoading"
              label="No"
              outline
              class="q-mr-xl"
              @click="onDialogCancel"
            />
            <PBtn
              :fluid="false"
              :loading="isLoading"
              label="Yes"
              type="submit"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { useDialogPluginComponent } from "quasar";

import CloseIcon from "assets/icons/close.svg";

defineEmits([...useDialogPluginComponent.emits]);

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent();

const isLoading = ref(false);

const props = defineProps({
  headerText: {
    type: String,
    required: true,
  },
  labelText: {
    type: String,
    required: true,
  },
  hintText: {
    type: String,
    required: true,
  },
  labelClass: {
    type: String,
    default: "",
  },
  hintClass: {
    type: String,
    default: "",
  },
  submitFunction: {
    type: Function,
    default: () => {},
  },
});

const onSubmit = async () => {
  try {
    isLoading.value = true;

    await props.submitFunction();

    onDialogOK();
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};
</script>
